import styled, { css } from 'styled-components';

import { setTypography } from 'utils/styles/mixins';
import { mediaDesktop } from 'utils/styles/responsive';
import { colors } from 'utils/styles/theme';

import { ReactComponent as SvgLinkArrow } from '../../../../../public/svgs/linkArrow.svg';

interface RowProps {
  textColor?: string;
}

export const JoinUsOpportunitiesWrapper = styled.div``;

export const Header = styled.div`
  grid-column: 2/-2;
  margin-bottom: 72px;

  ${mediaDesktop(css`
    margin-bottom: 90px;
    grid-column: 2/7;
  `)}
`;

export const Head = styled.div`
  ${({ theme: { locale } }) => setTypography('small', locale)}
  padding: 20px 0;
  border-bottom: 1px solid ${colors.white};
  grid-row: header;
`;

export const Title = styled.div`
  margin-bottom: 20px;
`;

export const Table = styled.div`
  grid-column: 2/-2;
  display: grid;

  border-top: 1px solid ${colors.white};

  ${mediaDesktop(css`
    border-top: none;
    grid-template-columns: max-content max-content max-content 1fr;
    grid-template-rows: [header-start] 50px [header-end row-start] auto [row-end];
    grid-auto-rows: auto;
    grid-auto-columns: auto;
  `)}

  position: relative;
`;

export const Row = styled.div<RowProps>`
  position: relative;
  display: grid;
  grid-template-columns: 1fr 1fr;
  cursor: pointer;

  &:hover {
    ${({ textColor }) =>
      textColor && `color: ${colors[textColor] ?? textColor}`};

    svg {
      ${({ textColor }) =>
        textColor && `color: ${colors[textColor] ?? textColor}`};
    }
  }

  > div {
    &:nth-child(2),
    &:nth-child(3) {
      border-bottom: 1px solid ${colors.white};
    }
  }

  ${mediaDesktop(css`
    display: contents;

    > div {
      border-bottom: 1px solid #ffffff;
    }

    p {
      transition: transform 0.3s ease-in;
    }

    &:hover > div {
      &:first-child {
        p {
          transform: translateX(20px);
        }
        padding-right: 170px;
      }
      &:last-child {
        svg {
          opacity: 1;
          transform: translateX(0);
        }
      }
    }
  `)}
`;

export const HeadRow = styled.div`
  display: none;

  ${mediaDesktop(css`
    position: relative;
    display: contents;
  `)}
`;

export const Col = styled.div`
  ${({ theme: { locale } }) => setTypography('body', locale)}
  padding: 20px 0;
  display: flex;
  align-items: center;

  &:first-child {
    grid-column: 1/-1;
    padding: 20px 0 20px 0;
  }

  &:last-child {
    display: none;
  }

  ${mediaDesktop(css`
    padding: 40px 0;
    padding-right: clamp(20px, 200rem, 170px);

    &:first-child {
      padding: 40px 0 40px 0;
      grid-column: auto;
      padding-right: 170px;
      max-width: 40vw;
    }

    :last-child {
      padding-right: 50px;
      display: flex;
      justify-content: flex-end;
      padding-right: 20px;
      svg {
        opacity: 0;
      }
    }
  `)}
`;

export const IconWrapper = styled.div`
  overflow: hidden;
`;

export const Icon = styled(SvgLinkArrow)`
  width: 30.98px;
  height: 25px;
  transition: transform 0.3s ease-in;
  transform: translateX(100%);
`;

export const ButtonWrapper = styled.div`
  grid-column: 2 / -2;
  margin-top: 40px;
  margin-bottom: 120px;

  ${mediaDesktop(css`
    grid-column: 2 / 5;
    margin-top: 80px;
    margin-bottom: 200px;
  `)}
`;
